import Model from '@/components/model/model'

class Site extends Model {

}


//import Site from '@/components/model/site/site'


//{{dev}}/service_api/pc_v1/site/index/read.html



Site.info = function ( params = {}) {
// if (!params.id ) {
//   return this.reject('请输入id');
// }
params.time = new Date().getTime();
    return this.get('/pc_v1/site/index/info.html', params)
}



/***

Promise.resolve('foo');//等价于如下
new Promise((resolve)=>{
    resolve('foo');
})



*/

Site.read = function ( params = {}) {

 // console.info("-->",params);


if (!params.id ) {
  //return new Promise((resolve, reject)=> { reject('请输入id'); });
  return this.reject('请输入id');
 // console.info(params,  '请输入id')
 // return false;
 // return p;
}
    return this.get('/pc_v1/site/index/read.html', params)
}




/**
 * 列表
 * @param {} params
 */
Site.index = function(params = {}) {
    return this.get('/pc_v1/site/index/index.html', params);
}



/* 创建保存 */
Site.save = function (params = {}) {
    return this.post('/pc_v1/site/index/save.html', params)
}

/* 编辑保存 */
Site.update = function (params = {}){
    if (!params.id) {
        return this.reject('请输入id！');
    }
    return this.put('/pc_v1/site/index/update.html', params);
}




Site.m_delete = function(params = {}) {
    if (!params.id) {
             return this.reject('请输入id！');
        }
    return this.r_delete('/pc_v1/site/index/m_delete.html', params);;
}




export default Site



// WEBPACK FOOTER //
// ./src/components/model/site/site.js